var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("report-filters", {
        attrs: {
          selectedLegalEntity: _vm.selectedLegalEntity,
          startDate: _vm.startDate,
          endDate: _vm.endDate,
          loading: _vm.loading,
          hasData: _vm.reportData && _vm.reportData.length > 0,
          reportType: "identification"
        },
        on: {
          "update:selectedLegalEntity": function($event) {
            _vm.selectedLegalEntity = $event
          },
          "update:selected-legal-entity": function($event) {
            _vm.selectedLegalEntity = $event
          },
          "update:startDate": function($event) {
            _vm.startDate = $event
          },
          "update:start-date": function($event) {
            _vm.startDate = $event
          },
          "update:endDate": function($event) {
            _vm.endDate = $event
          },
          "update:end-date": function($event) {
            _vm.endDate = $event
          },
          search: _vm.loadReportData,
          clear: _vm.clearFilters,
          export: _vm.exportToPdf
        }
      }),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "b-card",
                [
                  _c("b-card-title", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("reporting_channel.reports.identification.title")
                      )
                    )
                  ]),
                  _c(
                    "b-card-body",
                    [
                      !_vm.reportData || _vm.reportData.length === 0
                        ? _c(
                            "b-alert",
                            { attrs: { show: "", variant: "info" } },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "reporting_channel.reports.identification.no_data_message"
                                    )
                                  ) +
                                  " "
                              )
                            ]
                          )
                        : _c("b-table", {
                            staticClass: "mb-0",
                            attrs: {
                              items: _vm.reportData,
                              fields: _vm.tableFields,
                              striped: "",
                              hover: "",
                              responsive: "",
                              small: ""
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "cell(identification_status)",
                                fn: function(row) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          row.item.identification_status || "-"
                                        ) +
                                        " "
                                    )
                                  ]
                                }
                              },
                              {
                                key: "cell(total)",
                                fn: function(row) {
                                  return [
                                    _c(
                                      "strong",
                                      { staticClass: "text-primary" },
                                      [_vm._v(_vm._s(row.item.total))]
                                    )
                                  ]
                                }
                              },
                              {
                                key: "cell(percentual)",
                                fn: function(row) {
                                  return [
                                    _c(
                                      "strong",
                                      { staticClass: "text-success" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatPercentual(
                                              row.item.percentual
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ])
                          }),
                      _vm.reportData && _vm.reportData.length > 0
                        ? _c("div", { staticClass: "mt-3 text-right" }, [
                            _c("strong", { staticClass: "text-primary" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "reporting_channel.reports.identification.total_geral"
                                    )
                                  ) +
                                  ": " +
                                  _vm._s(_vm.totalGeral) +
                                  " "
                              )
                            ])
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }